import { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { HttpData } from '../../../Core';

const EditEmployeeNameModal = ({ employee, jwt, onHide, onUpdated }) => {
    const [name, setName] = useState(employee.name ?? '');
    const [firstName, setFirstName] = useState(employee.firstName ?? '');
    const [secondName, setSecondName] = useState(employee.secondName ?? '');
    const [thirdName, setThirdName] = useState(employee.thirdName ?? '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleSave = async e => {
        e.preventDefault();
        setSaving(true);
        setError(null);

        const response = await HttpData(`/api/v1/EmployeeRoles/${employee.multiAccountId}/name`, 'PUT', jwt, {
            name,
            firstName,
            secondName,
            thirdName: thirdName || null,
        });

        if (response.statusSuccessful) {
            onUpdated(response.data);
        } else {
            setError(response.errorData || 'Не удалось сохранить изменения');
        }

        setSaving(false);
    };

    return (
        <Modal show onHide={onHide} centered>
            <Form onSubmit={handleSave}>
                <Modal.Header closeButton>
                    <Modal.Title>Изменить ФИО</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && <div className="text-danger mb-2">{error}</div>}

                    <Form.Group className="mb-2">
                        <Form.Label><b>Name</b></Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label><b>Фамилия</b></Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={secondName}
                            onChange={e => setSecondName(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label><b>Имя</b></Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Отчество</Form.Label>
                        <Form.Control
                            type="text"
                            value={thirdName}
                            onChange={e => setThirdName(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={saving}>
                        Отмена
                    </Button>
                    <Button variant="primary" type="submit" disabled={saving}>
                        {saving ? 'Сохранение...' : 'Сохранить'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditEmployeeNameModal;
